export default "__VITE_ASSET__Dg3E1vm$__"